export enum RegistrationStatus {
    Pending = 1,    // Registration is submitted but not yet processed
    Approved = 2,   // Registration is reviewed and approved
    Rejected = 3,   // Registration is reviewed and rejected
    InProgress = 4, // Registration is being processed
    Completed = 5,  // Registration is successfully completed
    Cancelled = 6   // Registration was cancelled by the user or system
}

export const Status = {
    PENDING: "Pending",       // Registration is submitted but not yet processed
    APPROVED: "Approved",     // Registration is reviewed and approved
    REJECTED: "Rejected",     // Registration is reviewed and rejected
    IN_PROGRESS: "InProgress",// Registration is being processed
    COMPLETED: "Completed",   // Registration is successfully completed
    CANCELLED: "Cancelled"    // Registration was cancelled by the user or system
};


export enum REQUEST_STATUS {
    ERR_BAD_REQUEST = 400,
    ERR_UNAUTHORIZED = 401,
    ERR_FORBIDDEN = 403,
    ERR_BAD_RESPONSE = 500,
}

export enum CertificateType {
    URL = "URL",
    FILE = "FILE"
}